// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { CarePlanItemResponse } from './care-plan-item-response';

// @ts-ignore
import { PracticeDiagnosisResponse } from './practice-diagnosis-response';

/** See com.rev360.pms.api.controller.person.diagnosis.PersonDiagnosisResponse */
/* istanbul ignore next */
@GandalfModel
export class PersonDiagnosisResponse extends GandalfModelBase {

	@GandalfArray(CarePlanItemResponse)
	carePlanItemResponses!: CarePlanItemResponse[] | null;

	@GandalfArray(PersonDiagnosisResponse)
	childDiagnoses!: PersonDiagnosisResponse[] | null;

	@GandalfProperty({ designType: String })
	code!: string | null;

	@GandalfProperty({ designType: String })
	comment!: string | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	createdOn!: Date | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	diagnosisDate!: Date | null;

	@GandalfConstantDecorator(constants.DiagnosisLocation)
	@GandalfProperty({ designType: constants.DiagnosisLocation })
	diagnosisLocation!: constants.DiagnosisLocation | null;

	@GandalfConstantDecorator(constants.DiagnosisLocationQualifier)
	@GandalfProperty({ designType: constants.DiagnosisLocationQualifier })
	diagnosisLocationQualifier!: constants.DiagnosisLocationQualifier | null;

	@GandalfProperty({ designType: Number })
	encounterAutoDiagnosisId!: number | null;

	@GandalfProperty({ designType: Number })
	encounterId!: number | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ designType: Boolean })
	isPrimary!: boolean | null;

	@GandalfProperty({ designType: Boolean })
	isShowDisabledWarning!: boolean | null;

	@GandalfProperty({ designType: Boolean })
	needConversion!: boolean | null;

	@GandalfProperty({ designType: Number })
	originalDiagnosisId!: number | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	originalDiagnosisResolutionDate!: Date | null;

	@GandalfProperty({ designType: PersonDiagnosisResponse })
	parentDiagnosis!: PersonDiagnosisResponse | null;

	@GandalfProperty({ designType: Number })
	personId!: number | null;

	@GandalfProperty({ designType: PracticeDiagnosisResponse })
	practiceDiagnosis!: PracticeDiagnosisResponse | null;

	@GandalfProperty({ designType: String })
	reason!: string | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	resolutionDate!: Date | null;

	@GandalfProperty({ designType: String })
	shortDescription!: string | null;

	@GandalfConstantDecorator(constants.PersonDiagnosisStatus)
	@GandalfProperty({ designType: constants.PersonDiagnosisStatus })
	status!: constants.PersonDiagnosisStatus | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	updatedOn!: Date | null;

}
